export default "__VITE_ASSET__3ca4ca98__"